// ** Modules
import React from 'react';

const PODIGEE_SCRIPT_SRC = 'https://player.podigee-cdn.net/podcast-player/javascripts/podigee-podcast-player.js';

const PodcastPlayer = ({ configUrl }: { configUrl: string }) => {
	React.useEffect(() => {
		if (!configUrl) return;

		// Load the base Podigee player script ONCE
		const existingScript = document.querySelector(`script[src="${PODIGEE_SCRIPT_SRC}"]`);
		if (!existingScript) {
			const playerScript = document.createElement('script');
			playerScript.src = PODIGEE_SCRIPT_SRC;
			playerScript.async = true;
			document.body.appendChild(playerScript);
		}

		// Inject player instance script
		const script = document.createElement('script');
		script.className = 'podigee-podcast-player';
		script.setAttribute('data-configuration', configUrl);
		script.async = true;

		const container = document.getElementById(`podigee-player-${configUrl}`);
		container?.appendChild(script);

		return () => {
			if (container) {
				container.innerHTML = '';
			}
		};
	}, [configUrl]);

	return <div id={`podigee-player-${configUrl}`} />;
};

export default PodcastPlayer;
